/**
 * Corporation Resource Histogram view, one blob per signed-in user.
 * localStorage is per browser; the key is the Entra account so two people
 * on the same browser do not share a program, legend, or slicer set.
 * A refresh reads this blob before the first fetch.
 */

const PREFIX = 'fab-histogram-view-v1:';

export function histogramUserKey(account) {
  if (!account) return '';
  return String(account.localAccountId || account.username || '').trim().toLowerCase();
}

function storageKey(userKey) {
  return `${PREFIX}${String(userKey || '').trim().toLowerCase()}`;
}

export function loadFabHistogramView(userKey) {
  if (!String(userKey || '').trim()) return null;
  try {
    const raw = localStorage.getItem(storageKey(userKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function saveFabHistogramView(userKey, prefs) {
  if (!String(userKey || '').trim()) return;
  try {
    localStorage.setItem(storageKey(userKey), JSON.stringify({ ...prefs, _savedAt: Date.now() }));
  } catch {
    /* storage full / private mode — view prefs are best-effort */
  }
}
